import { sanitizeInputToBlankOrInput } from "./LineItemsUtilities";

/* FROM getLineItemsHeaders()
  0:  "Account Type",
  1:  "Account Number",
  2:  "Cost Center",
  3:  "Internal Order",
  4:  "Profit Center",
  5:  "Trading Partner",
  6:  "Material Group",
  7:  "Tax Code",
  8:  "Tax Jurisdiction Code",
  9:  "Line Desc.",
  10:  "Document Amount"
 */
export interface IErrorTypes {
  VendorOrCustomer: string;
  AtLeastTwoLineItemsNeeded: string;
  VendorAndCustomerInEntry: string;
  MultipleVendorsOrCustomersInEntry: string;
}

export enum ErrorTypes {
  // Used when there is a Vendor or Customer to make sure Cost Center, Internal Order, and Profit Center are blank
  VendorOrCustomer = "VendorOrCustomer",
  AtLeastTwoLineItemsNeeded = "AtLeastTwoLineItemsNeeded",
  // Used to make sure Entry does not have a Vendor AND a Customer account type in the same entry
  VendorAndCustomerInEntry = "VendorAndCustomerInEntry",
  // There can't be two same Accounts Number of type Vendor or Customer
  // invalid
  // ========
  // v1 -- acc1
  // v1 -- acc1
  // v1 -- acc2
  //
  // c1 -- acc1
  // c1 -- acc1
  // c1 -- acc2
  //
  // v1 -- acc1
  // c1 -- acc1
  //
  // valid
  // ======
  // c1 -- acc1-200.00
  // c1 -- acc1-100.72
  MultipleVendorsOrCustomersInEntry = "MultipleVendorsOrCustomersInEntry"
}

// If Account Type is Vendor OR Customer then Cost Center, Internal Order, and Profit Center must be blank string
export function accountTypeValidation(row: string[]): boolean {
  const costCenter = sanitizeInputToBlankOrInput(row[2]);
  const internalOrder = sanitizeInputToBlankOrInput(row[3]);
  const profitCenter = sanitizeInputToBlankOrInput(row[4]);
  if (costCenter !== "" || internalOrder !== "" || profitCenter !== "") {
    return true;
  }
  return false;
}
